import { createFileRoute } from '@tanstack/react-router';

import { GameModePreferenceStep } from '@/features/onboarding/components/steps/lf/gameModePreferenceStep';

export const Route = createFileRoute(
  '/_protected/onboarding/_steps/game-mode-preference',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <GameModePreferenceStep />;
}
